import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import signInApi from "../api/signInApi";
import { getUser, deleteAllCookies } from "../utils/cookieAuth";

// create slice
const name = "auth";
const initialState = createInitialState();
// const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    // initialize state from local storage to enable user to stay logged in
    user: getUser() != null ? JSON.parse(getUser()) : null,
    permissions: JSON.parse(localStorage.getItem("permissions")) || [],
    error: null,
  };
}

// function createReducers() {
//   return {
//     logout,
//   };

//   function logout(state) {
//     state.user = null;
//     deleteAllCookies();
//     console.log('xxxxxxxxxxx');
//     // localStorage.removeItem("user");
//   }
// }

function createExtraActions() {
  return {
    login: login(),
    logout: logout(),
  };

  function login() {
    return createAsyncThunk(
      `${name}/login`,
      async (data) => await signInApi.login(data)
    );
  }
  function logout() {
    return createAsyncThunk(
      `${name}/logout`,
      async () => await signInApi.logout()
    );
  }
}

function createExtraReducers() {
  return {
    ...login(),
    ...logout(),
  };

  function login() {
    const { pending, fulfilled, rejected } = extraActions.login;
    return {
      [pending]: (state) => {
        state.error = null;
      },
      [fulfilled]: (state, action) => {
        const user = action.payload;
        // // store user details and jwt token in local storage to keep user logged in between page refreshes
        // localStorage.setItem("user", JSON.stringify(user.data));
        state.user = user.data.user;
        state.permissions = user.data?.permissions;
        // get return url from location state or default to home page
      },
      [rejected]: (state, action) => {
        state.error = action.payload;
      },
    };
  }

  function logout() {
    const { pending, fulfilled, rejected } = extraActions.logout;
    return {
      [pending]: (state) => {
        state.user = null;
      },
      [fulfilled]: (state, action) => {
        // // store user details and jwt token in local storage to keep user logged in between page refreshes
        // localStorage.setItem("user", JSON.stringify(user.data));
        state.user = null;
        localStorage.removeItem("permissions");
        deleteAllCookies();
        // get return url from location state or default to home page
      },
      [rejected]: (state, action) => {
        state.user = null;
        deleteAllCookies();
      },
    };
  }
}
